import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
} from "@insite/client-framework/HandlerCreator";
import { QuoteModel } from "@insite/client-framework/Types/ApiModels";
import { CustomApiHandlerDiscreteParameter } from "@tJohnstonCompanies/Handlers/CustomHandlerCreator";
import { UpdateQuoteApiParameterextent } from "@tJohnstonCompanies/Overrides/Store/Pages/RfqQuoteDetails/SubmitQuote";
import { updateQuote as updateQuoteApi } from "@tJohnstonCompanies/Services/CustomQuoteService";

type HandlerType = CustomApiHandlerDiscreteParameter<
    {
        quote: QuoteModel;
    } & HasOnSuccess &
        HasOnError<string>,
    UpdateQuoteApiParameterextent,
    QuoteModel
>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = {
        quoteId: props.parameter.quote.id,
        status: "QuoteProposed",
        expirationDate: props.parameter.quote.expirationDate || undefined,
        properties: {
            carrierID: (props.getState() as any).customState.carrier.id || "",
            shipViaID: (props.getState() as any).customState.shipVia.id || "",
            accountNumber: (props.getState() as any).customState.accountNumber || "",
        },
    };
};

export const SendDataToApi: HandlerType = async props => {
    const result = await updateQuoteApi(props.apiParameter);
    if (result.successful) {
        props.apiResult = result.result;
    } else {
        props.parameter.onError?.(result.errorMessage);
        return false;
    }
};

export const DispatchCompleteLoadQuote: HandlerType = props => {
    props.dispatch({
        type: "Data/Quotes/CompleteLoadQuote",
        quote: props.apiResult,
    });
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    props.parameter.onSuccess?.();
};
export const EmptyCustomState: HandlerType = props => {
    props.dispatch({
        type: "Custom/RfqQuoteDetailsNew/SetAccountNumber",
        accountNumber: undefined,
    });
    props.dispatch({
        type: "Custom/RfqQuoteDetailsNew/SetShipVia",
        shipVia: undefined,
    });
    props.dispatch({
        type: "Custom/RfqQuoteDetailsNew/SetCarrier",
        carrier: undefined,
        iseditable: false,
    });
};

export const chain = [
    PopulateApiParameter,
    SendDataToApi,
    DispatchCompleteLoadQuote,
    ExecuteOnSuccessCallback,
    EmptyCustomState,
];

const approvalQuote = createHandlerChainRunner(chain, "ApprovalQuote");
export default approvalQuote;
